"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AppHeaderItem = require("../AppHeaderItem");
var _excluded = ["type", "size", "disabled", "icon", "alt", "className", "buttonType"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var IconButton = function IconButton(_ref, ref) {
  var type = _ref.type,
    size = _ref.size,
    disabled = _ref.disabled,
    icon = _ref.icon,
    alt = _ref.alt,
    className = _ref.className,
    _ref$buttonType = _ref.buttonType,
    buttonType = _ref$buttonType === void 0 ? 'button' : _ref$buttonType,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = (0, _classnames["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
    'icon-btn': true
  }, "icon-btn-".concat(type), type && !Object.keys(_AppHeaderItem.ICON_BUTTON_CLASS_MAP).includes(type)), "icon-btn-".concat(size), size), "disabled", disabled), _AppHeaderItem.ICON_BUTTON_CLASS_MAP[type], className);
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
    type: buttonType,
    className: classes,
    ref: ref,
    disabled: disabled,
    "aria-label": alt
  }, rest), /*#__PURE__*/_react["default"].createElement("i", {
    className: icon,
    role: "img",
    "aria-label": alt
  }));
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(IconButton);